//production server
// export const API_BASE_URL = 'http://94.229.79.27:55412/api/v1';

//live server
export const API_BASE_URL = 'https://portal-lasrra.touchandpay.me/public/';
export const getApiUrl = (endpoint) => API_BASE_URL + endpoint



export const LOGIN = getApiUrl('v1/gw/authenticate');
export const GETLASSRAUSER = getApiUrl('v1/gw/request');







